export default __webpack_public_path__ + "88c60aa84992a0c94862e1556f39f153.svg";